var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Divider, Box } from 'wix-style-react';
import { translate } from 'react-i18next';
import { newMobileViewBreakpoint } from '../../core';
import RecurringInvoiceView from '../RecurringInvoicesView/RecurringInvoicesView';
import Status from '../InvoiceViewV2/Status';
import { FooterNotes, InfoLine, InfoSection, InvoiceHeader, InvoiceHighlight, InvoiceSummary, LineItem, } from './components';
import { useHooks } from './useHooks';
import { formatBusinessAddress, formatCustomerAddresses } from './utils';
var HideOnPrint = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { className: "hide-on-print" },
        React.createElement("style", null, "@media print {.hide-on-print{display: none;}}"),
        children));
};
export var DEFAULT_LAYOUT_COLOR = '#F0F2F5';
var MobileInvoiceView = function (_a) {
    var businessInfo = _a.businessInfo, newSubdivisionFormatEnabled = _a.newSubdivisionFormatEnabled, onInvoiceReady = _a.onInvoiceReady, _b = _a.recurringInvoiceViewEnabled, recurringInvoiceViewEnabled = _b === void 0 ? false : _b, showTaxBreakdown = _a.showTaxBreakdown, showTaxPerLineItem = _a.showTaxPerLineItem, t = _a.t, rest = __rest(_a, ["businessInfo", "newSubdivisionFormatEnabled", "onInvoiceReady", "recurringInvoiceViewEnabled", "showTaxBreakdown", "showTaxPerLineItem", "t"]);
    var _c = useHooks(__assign(__assign({}, rest), { recurringInvoiceViewEnabled: recurringInvoiceViewEnabled, t: t })), businessDetailsCustomFieldsContent = _c.businessDetailsCustomFieldsContent, dateFormatter = _c.dateFormatter, documentCustomFieldsContent = _c.documentCustomFieldsContent, dueAmount = _c.dueAmount, footerNotesProps = _c.footerNotesProps, invoiceDetails = _c.invoiceDetails, invoiceNumberLabel = _c.invoiceNumberLabel, invoiceSummaryProps = _c.invoiceSummaryProps, moneyFormatter = _c.moneyFormatter, orderReference = _c.orderReference, showFooterNotes = _c.showFooterNotes, showInvoiceHighlight = _c.showInvoiceHighlight, showInvoiceStatus = _c.showInvoiceStatus;
    var renderInvoiceDetails = function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(InfoLine, { heading: true, paddingTop: "24px" }, invoiceNumberLabel),
            React.createElement(InfoLine, { paddingTop: "8px", weight: "bold" }, orderReference),
            React.createElement(InfoLine, null, (_a = invoiceDetails.metaData.sourceProperties) === null || _a === void 0 ? void 0 : _a.referenceText),
            showInvoiceStatus && (React.createElement(HideOnPrint, null,
                React.createElement(Box, { marginTop: "8px", marginBottom: "8px" },
                    React.createElement(Status, { isUoU: true, isOutlined: true, status: invoiceDetails.status })))),
            React.createElement(InfoSection, { title: invoiceDetails.title, content: [
                    invoiceDetails.issueDate
                        ? "".concat(t('quote.form.issue_date'), ": ").concat(dateFormatter(new Date(invoiceDetails.issueDate)))
                        : undefined,
                    invoiceDetails.dueDate
                        ? "".concat(t('quote.form.due_date'), ": ").concat(dateFormatter(new Date(invoiceDetails.dueDate)))
                        : undefined,
                ] }),
            React.createElement(InfoSection, { marginTop: "8px", content: documentCustomFieldsContent }),
            React.createElement(InfoSection, { marginTop: "24px", title: businessInfo.name, content: __spreadArray(__spreadArray([
                    businessInfo.email,
                    businessInfo.phone
                        ? t('price-quote.view.business.phone', {
                            phone: businessInfo.phone,
                        })
                        : undefined
                ], formatBusinessAddress(businessInfo.businessAddress, t), true), [
                    businessInfo.companyId
                        ? t('price-quote.view.business.company-id', {
                            companyId: businessInfo.companyId,
                        })
                        : undefined,
                ], false) }),
            React.createElement(InfoSection, { marginTop: "8px", content: businessDetailsCustomFieldsContent }),
            formatCustomerAddresses(invoiceDetails.customer, t, newSubdivisionFormatEnabled).map(function (infoSectionProps, index) { return (React.createElement(InfoSection, __assign({ marginTop: index === 0 ? '24px' : '16px' }, infoSectionProps))); })));
    };
    var renderLineItems = function () {
        if (!invoiceDetails.lineItems.length) {
            return undefined;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(InfoLine, { heading: true, paddingTop: "24px", paddingBottom: "24px" }, t('price-quote.view.line-items.products-and-services-heading')),
            invoiceDetails.lineItems.map(function (lineItem, index, _a) {
                var length = _a.length;
                return (React.createElement(LineItem, { key: "LineItem_".concat(index), formatMoney: moneyFormatter, isLast: index === length - 1, lineItem: lineItem, showTax: showTaxPerLineItem, t: t }));
            })));
    };
    /** TODO: missing design */
    var renderRecurringInvoiceView = function () {
        return recurringInvoiceViewEnabled && (React.createElement(RecurringInvoiceView, { darkView: false, 
            // TODO: abstract this away once rewritten
            invoice: rest.invoice, isReady: true, newMobileView: true, recurringStandaloneViewEnabled: false }));
    };
    return (React.createElement(Box, { maxWidth: "".concat(newMobileViewBreakpoint, "px"), direction: "vertical" },
        React.createElement(InvoiceHeader, { background: DEFAULT_LAYOUT_COLOR, businessName: businessInfo.name, logo: businessInfo.logo, onImageReady: onInvoiceReady }),
        renderRecurringInvoiceView(),
        React.createElement(Box, { backgroundColor: "white", direction: "vertical", paddingLeft: "5%", paddingRight: "5%" },
            showInvoiceHighlight && (React.createElement(React.Fragment, null,
                React.createElement(InvoiceHighlight, { amountPaid: moneyFormatter(invoiceDetails.paid), dueAmount: moneyFormatter(dueAmount), dueDate: dateFormatter(invoiceDetails.dueDate), t: t }),
                React.createElement(Box, { marginTop: "24px" },
                    React.createElement(Divider, null)))),
            renderInvoiceDetails(),
            React.createElement(Box, { marginTop: "24px" },
                React.createElement(Divider, null)),
            renderLineItems(),
            React.createElement(InvoiceSummary, __assign({}, invoiceSummaryProps, { formatMoney: moneyFormatter, showTaxBreakdown: showTaxBreakdown, t: t })),
            showFooterNotes && (React.createElement(React.Fragment, null,
                React.createElement(Box, { marginTop: "20px", height: "8px", background: DEFAULT_LAYOUT_COLOR }),
                React.createElement(FooterNotes, __assign({}, footerNotesProps, { t: t })))))));
};
export var MobileInvoicePreview = translate(['invoice-view', 'locale-data'], {
    wait: true,
})(MobileInvoiceView);
//# sourceMappingURL=MobileInvoiceView.js.map